import React, { useState } from 'react';
import * as api from '../../../api/shareCampaignsAPI';

import {
	FacebookIcon,
	FacebookShareButton,
	LinkedinIcon,
	LinkedinShareButton,
	TwitterIcon,
	TwitterShareButton,
	WhatsappIcon,
	WhatsappShareButton,
} from 'react-share';
import { Helmet } from 'react-helmet';

const SendShareCampaign = ({
	orgID,
	shouldShow,
	setShouldShow,
	isSubscribed,
	opportunityData,
}) => {
	const shareCampaignObjectTemplate = {
		full_name: '',
		email: '',
		body: '',
	};

	const [shareCampaignData, setShareCampaignData] = useState(
		shareCampaignObjectTemplate
	);

	const handleChange = (event) => {
		let attribute = event.target.id;
		let value = event.target.value;
		shareCampaignData[attribute] = value;
		let element = document.getElementById(attribute + '-empty-label');
		if (element) {
			if (value === '') {
				element.style.display = 'block';
			} else {
				element.style.display = 'none';
			}
		}
		setShareCampaignData(shareCampaignData);
	};

	const handleClose = () => {
		setShouldShow(false);
	};

	const handleSend = async () => {
		let fullName = document.getElementById('full_name').value;
		let email = document.getElementById('email').value;
		let body = document.getElementById('body').value;

		if (fullName && email && body) {
			console.log('Full name: ', fullName);
			console.log('Email: ', email);
			console.log('Message: ', body);
			handleClose();

			try {
				await api.postShareCampaign(shareCampaignData, orgID);
				// location.assign(`/organizations/${orgID}`);
			} catch (error) {
				console.error(error);
			}
		} else {
			if (!fullName) {
				let element = document.getElementById('full-name-empty-label');
				if (element) element.style.display = 'block';
			}
			if (!email) {
				let element = document.getElementById('email-empty-label');
				if (element) element.style.display = 'block';
			}
			if (!body) {
				let element = document.getElementById('body-empty-label');
				if (element) element.style.display = 'block';
			}
		}
	};

	const ShareViaSocials = () => {
		let sharedUrl = window.location.href;

		return (
			<>
				<div>
					<FacebookShareButton url={sharedUrl}>
						<FacebookIcon size={32} round />
					</FacebookShareButton>
					<LinkedinShareButton url={sharedUrl}>
						<LinkedinIcon size={32} round />
					</LinkedinShareButton>
					<TwitterShareButton url={sharedUrl}>
						<TwitterIcon size={32} round />
					</TwitterShareButton>
					<WhatsappShareButton url={sharedUrl}>
						<WhatsappIcon size={32} round />
					</WhatsappShareButton>
				</div>
			</>
		);
	};

	return shouldShow ? (
		isSubscribed ? (
			<div className="send-share-profile">
				<div className="background-filter" onClick={handleClose} />

				<div className="foreground">
					<i
						id="media-upload-close-button"
						className="fas fa-times float-right"
						onClick={handleClose}
					/>
					<h3 className="title-text">
						Share this campaign with the world!
					</h3>
					<h3 className="subtitle-text">
						Be sure to upload images, videos and media to best
						showcase your campaign
					</h3>

					<ShareViaSocials />
					<label className="labels">Full name</label>
					<input
						className="full_name-input"
						type="text"
						placeholder="Enter your name here. Ex. Joe Smith"
						id="full_name"
						onChange={(e) => handleChange(e)}
					/>
					<div>
						<label
							className="empty-field-label"
							id="full-name-empty-label"
						>
							{'Name field cannot be left blank!'}
						</label>
					</div>

					<label className="labels">Email</label>
					<input
						type="text"
						placeholder="Enter your email here. Ex. joesmith@example.com"
						id="email"
						onChange={(e) => handleChange(e)}
					/>
					<div>
						<label
							className="empty-field-label"
							id="email-empty-label"
						>
							{'Email field cannot be left blank!'}
						</label>
					</div>

					<label className="labels">Message</label>
					<textarea
						placeholder="Enter your introduction here!"
						id="body"
						onChange={(e) => handleChange(e)}
					/>
					<div>
						<label
							className="empty-field-label"
							id="body-empty-label"
						>
							{'Message field cannot be left blank!'}
						</label>
					</div>
					<div
						className="primary-button float-right"
						onClick={handleSend}
					>
						<p>Send</p>
					</div>
				</div>
			</div>
		) : (
			<div className="send-share-profile">
				<div className="background-filter" onClick={handleClose} />

				<div className="foreground">
					<i
						id="media-upload-close-button"
						className="fas fa-times float-right"
						onClick={handleClose}
					/>
					<h2 className="title-text">
						In order to access this feature, you must be subscribed.
					</h2>
					<h2 className="title-text">
						Check out our{' '}
						<a href={'/accounts'}>subscription options</a> to access
						this and many other amazing features!
					</h2>
				</div>
			</div>
		)
	) : (
		<></>
	);
};

export default SendShareCampaign;
